import fnsFormat from 'date-fns/format';

export const getTime = (timeStampSec: string) => {
  return new Date(parseInt(timeStampSec) * 1000);
};

export const isExpired = (endTimestampSec: string): boolean => {
  const end = new Date(parseInt(endTimestampSec) * 1000).getTime();
  const now = new Date().getTime();
  return end < now;
};

export const getExpectedDate = (dateString: string, isMs = false): string => {
  if (!dateString) {
    return '';
  }
  const date = isMs
    ? new Date(parseInt(dateString) * 1000)
    : new Date(dateString);
  const hour = date.getHours();
  return `${
    hour === 8 ? '8:00 - 11:00 ' : hour === 14 ? '14:00 - 18:00 ' : ''
  }${fnsFormat(date, 'dd/MM/yyyy')}`;
};

/**
 * Get the minimum time from an array of timestamp second
 *
 * @returns The minimum time: Date | null (if array is empty)
 *
 * @param timestampSecList
 */
export const getMinimumTime = (timestampSecList: string[]): Date | null => {
  if (timestampSecList.length === 0) return null;
  let minimumTime = new Date();
  minimumTime.setHours(23, 59, 59);
  timestampSecList.forEach((timestampSec) => {
    // convert to Date format
    const currentTime = new Date(parseInt(timestampSec) * 1000);
    if (currentTime < minimumTime) minimumTime = currentTime;
  });
  return minimumTime;
};
